"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _toolkit = require('@reduxjs/toolkit');




var _user = require('shared/selectors/user');
var _common = require('./common');
var _time = require('shared/services/time');
var _unread = require('shared/services/unread');















const EMPTY_MAP = {}

 const makeSelectBlobjectMetadata = () => _toolkit.createSelector.call(void 0, 
  _common.selectBlobjectByKey,
  _user.selectCurrentUserV2,
  (blobject, me) => {
    if (!blobject) return EMPTY_MAP

    const {
      Name: name,
      Description: description,
      IsNamed: isNamed,
      WrappedKey: wrappedKey,
      WrappedType: wrappedType,
      InboxSortTime: lastUpdated,
      UserSubscribers: userSubscribers,
    } = blobject

    const userMetadata = blobject.UserMetadata[me.UserKey] 
    const isUnread = _unread.isUnreadForMe.call(void 0, blobject, me.UserKey)
    const amIParticipatingAsUser = !!userSubscribers[me.UserKey]
    const isCompleted = !!_optionalChain([userMetadata, 'optionalAccess', _ => _.Completed])
    const unreadMentions = blobject.UnreadMentions || 0

    const isMuted = !!(
      userMetadata && (
        _optionalChain([userMetadata, 'optionalAccess', _2 => _2.MuteForever]) ||
        _time.isAfter.call(void 0, _optionalChain([userMetadata, 'optionalAccess', _3 => _3.MuteUntil]), new Date())
      )
    )

    return {
      wrappedKey,
      wrappedType,
      name,
      isNamed,
      description,
      lastUpdated,
      isUnread,
      unreadMentions,
      isCompleted,
      amIParticipatingAsUser,
      isMuted,
    }
  },
); exports.makeSelectBlobjectMetadata = makeSelectBlobjectMetadata

 const selectBlobjectMetadata = exports.makeSelectBlobjectMetadata.call(void 0, ); exports.selectBlobjectMetadata = selectBlobjectMetadata
